import { z } from 'zod'
import { createIncomeSchema } from './create-income.schema'

export const batchCreateIncomesSchema = z.object({
  incomes: z.array(createIncomeSchema).min(1).max(500),
})

export type BatchCreateIncomesDto = z.infer<typeof batchCreateIncomesSchema>
